<script setup lang="ts">
    import { IUnsolicitedDocumentAuditResponse } from '../../lib/Models/DocumentModel';
    import { onMounted, ref, computed } from 'vue';
    import ChoiceTable from "../../components/ChoiceTable.vue";
    import * as DateUtils from '../../lib/DateUtils';
    import * as ChoiceEnums from '../../Enums/ChoiceEnums';
    import * as UIEnums from '../../Enums/UiEnums';
    import { ICol, RenderModeType, ValueStrDelegate, IRowSelection } from "../../lib/ChoiceTableHelpers";
    import ActionButton from "../../components/ActionButton.vue"; 

    const props = withDefaults(defineProps<{
        auditData?: IUnsolicitedDocumentAuditResponse[]
    }>(), {
    });

    const formatLogTypeDesc: ValueStrDelegate = (value: any, col: ICol, row: Record<string, any> | undefined, rowType: UIEnums.TableRowType): string | undefined => {
        if (rowType === UIEnums.TableRowType.Body)
        {
             return getSecurityLoggingTypeDesc(row?.auditType);
        }
    }

    const tableColumns = ref<ICol[]>([
        { Name: 'Audit Date', DataField: 'auditDate', RenderMode: RenderModeType.DateTime }, 
        { Name: 'Audit Type', DataField: 'auditType', FormatValue: formatLogTypeDesc },
        { Name: 'Transaction Id', DataField: 'transactionId' },
        { Name: 'User', DataField: 'userId' },
        { Name: 'Description', DataField: 'detailDescription' },
        { Name: 'Old Value', DataField: 'oldValue' },
        { Name: 'New Value', DataField: 'newValue' }
    ]);

    
    function getSecurityLoggingTypeDesc(value: string): string | undefined {
        switch (value) {
            case ChoiceEnums.SecurityLoggingType.ConsultPrint:
                return "Consult Print";
            case ChoiceEnums.SecurityLoggingType.ConsultView:
                return "Consult View";
            case ChoiceEnums.SecurityLoggingType.Export:
                return "Export";
            case ChoiceEnums.SecurityLoggingType.Fax:
                return "Fax";
            case ChoiceEnums.SecurityLoggingType.Insert:
                return "Insert";
            case ChoiceEnums.SecurityLoggingType.LogView:
                return "Log View";
            case ChoiceEnums.SecurityLoggingType.MeaningfulUse:
                return "Meaningful Use";
            case ChoiceEnums.SecurityLoggingType.Modified:
                return "Modified";
            case ChoiceEnums.SecurityLoggingType.Print:
                return "Print";
            case ChoiceEnums.SecurityLoggingType.Search:
                return "Search";
            case ChoiceEnums.SecurityLoggingType.Signoffy:
            return "Signoff";
            case ChoiceEnums.SecurityLoggingType.Signoffz:
                return "Signoff";
            case ChoiceEnums.SecurityLoggingType.UndoSignoff:
                return "Undo Signoff";
            case ChoiceEnums.SecurityLoggingType.View:
                return "View";
            default:
                return value;
        }
    }

    function closeWindow() {
        window.close();
    }

</script>

<template>
    <div class="row pt-2">
        <ChoiceTable 
            :columns="tableColumns" 
            :data="props.auditData" 
            :show-filters="true" 
            :allowSorting="true"
            key-value-data-member="documentId"
            >
        </ChoiceTable>  
    </div>
    <div class="row">
        <hr>
        <div class="text-end pe-3">
            <ActionButton
                baseText = "Close"
                spinText = "Closing Window"
                :disabled="false"   
                :executing="false"    
                :clickEvent="closeWindow" 
                :toolTip="'Close the Window'"
                :executeInit="false"
                :width="80">
            </ActionButton>        
        </div>
    </div>
</template>